














































import { Vue } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";
import pinLocationMapVue from "./pin-location-map.vue";
import tripDetailsVue from "./trip-details.vue";

export default Vue.component("trip-wizard", {
  Components: {
    pinLocationMapVue,
    tripDetailsVue,
  },
  data() {
    return {
      staticContent,
      trackingOpen: false,
    };
  },
  created() {
    this.selectedTrip.customerStop &&
      this.selectedTrip.customerStop.location &&
      (this.trackingOpen = true);
  },
  computed: {
    photosUrlEnum() {
      return this.$root.photosUrlEnum;
    },
    selectedTrip() {
      return this.$root.selectedTrip;
    },
    isRTL() {
      return this.$root.isRTL;
    },
  },
  methods: {
    showTracking() {
      this.trackingOpen = true;
    },
    getURL(url, size) {
      return this.$root.updatePhotosURL(url, size);
    },
  },
});
